import React, { useEffect, useState } from 'react'
import ApiRequest from '../Common/restservice';
import { useNavigate } from 'react-router-dom';
import { errorToast, successToast } from '../Common/showtoast';
import Swal from 'sweetalert2';

function Transfer() {
    const [userid, setUserid] = useState("");
    const [companywallet, setcompanywallet] = useState("");
    const [amount, setAmount] = useState("");
    const [membername, setmembername] = useState("");
    const navigate = useNavigate();
    useEffect(() => {
        GetDashboardDetails();
    }, [])
    const GetDashboardDetails = async () => {
        let res = await ApiRequest("GetDashboardDetails.asp", "GET", null, { Authorization: localStorage.getItem("token") });
        if (res.status === "error") {
            if (res.message === "Session Expired") {
                localStorage.clear();
                navigate("/login");
            }
            return;
        }
        setcompanywallet(res.availablecompanywallet);
    }
    const onTransferConfirm = async (json) => {
        let res = await ApiRequest("CompanyWalletTransfer.asp", "POST", json, { Authorization: localStorage.getItem("token") });
        console.log(res);
        if (res.status === "error") {
            errorToast(res.message);
            if (res.message === "Session Expired") {
                localStorage.clear();
                navigate("/login");
            }
            return;
        }
        successToast(res.message);
        setUserid("");
        setAmount("");
        GetDashboardDetails();
    }
    const getName = async () => {
        if (!userid) {
            return;
        }
        let jsoninput = {
            memberid: userid
        }
        let res = await ApiRequest("getname.asp", "POST", jsoninput, { Authorization: localStorage.getItem("token") });
        if (res.status === "error") {
            errorToast(res.message);
            if (res.message === "Session Expired") {
                localStorage.clear();
                navigate("/login");
            }
            return;
        }
        successToast(res.message);
        setmembername(res.fullname);
    }
    return (
        <section className='content'>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-xm-12">
                    <div className="card overflow-hidden dash1-card border-0 ">
                        <div className="card-body">
                            <h3 className=" mt-3 mb-3 text-center">Main Wallet Transfer</h3>
                            <div className="col-lg-12 row mt-2">
                                <label className="col-lg-6 col-md-12 col-form-label mt-2" type="button">Main Wallet Balance</label>
                                <h6 className="col-lg-6 col-md-12 mt-2 text-center">Rs. {companywallet || 0}</h6>
                                <label className="col-lg-6 col-md-12 mt-2 col-form-label" type="button">User Id</label>
                                <div className=' col-lg-6 col-md-12'>
                                    <input type="text" className=" mt-2 form-control" placeholder="Please enter user id " aria-label="Amount" tabIndex="1" value={userid} onChange={(e) => {
                                        setUserid(e.target.value)
                                    }} onBlur={(e) => getName()} />
                                </div>
                                <label className="col-lg-6 col-md-12 col-form-label mt-2" type="button">Name of the user</label>
                                <div className=' col-lg-6 col-md-12'>
                                    <input type="text" className="col-lg-6 col-md-12 form-control mt-2" placeholder="Name of the user" readOnly aria-label="membername" tabIndex="1" value={membername} />
                                </div>
                                <label className="col-lg-6 col-md-12 col-form-label mt-2" type="button">Amount to transfer</label>
                                <div className=' col-lg-6 col-md-12'>
                                    <input type="text" className="col-lg-6 col-md-12 form-control mt-2" placeholder="Please enter amount" aria-label="Amount" tabIndex="1" value={amount} onChange={(e) => {
                                        setAmount(e.target.value)
                                    }} />
                                </div>
                            </div>
                            <div className="col-lg-12 col-md-12 text-center" >
                                <button className="btn btn-primary mt-5" onClick={async (e) => {
                                    if (!userid) {
                                        errorToast("Enter valid userid");
                                        return;
                                    } else if (!amount) {
                                        errorToast("Enter valid amount");
                                        return;
                                    }
                                    let res = await ApiRequest("CompanyWalletTransferConfirm.asp", "POST", {
                                        transferamt: amount,
                                        transferto: userid
                                    }, { Authorization: localStorage.getItem("token") });
                                    console.log(res);
                                    if (res.status === "error") {
                                        errorToast(res.message);
                                        if (res.message === "Session Expired") {
                                            localStorage.clear();
                                            navigate("/login");
                                        }
                                        return;
                                    }
                                    successToast(res.message);
                                    const { value: tac } = await Swal.fire({
                                        title: 'Please enter your login password',
                                        input: 'password',
                                        inputLabel: 'Your Password',
                                        inputPlaceholder: 'Enter your login password',
                                        showCancelButton: true,
                                        inputValidator: (value) => {
                                            if (!value) {
                                                return 'Please enter your login password or cancel!'
                                            }
                                        }
                                    })
                                    if (!tac) {
                                        return;
                                    }
                                    var t = {
                                        transferamt: amount,
                                        transferto: userid,
                                        tac: tac
                                    };
                                    await onTransferConfirm(t)
                                }}>Transfer</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </section >
    )
}

export default Transfer
